import Api from './api.service';

export default {
  searchCnpj: (cnpj) => {
    return Api.get(`consult-cnpj/${cnpj}`);
  },
};
